var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',_vm._b({attrs:{"active":_vm.active},on:{"update:active":_vm.updateActive,"close":function($event){return _vm.$emit('close')}}},'vs-popup',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }